module.exports = __webpack_public_path__ + "static/media/kneeling-reaching-svgrepo-com.e112bd87.svg";